import React from 'react';
import "../../styles/table-main/main.css";

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Programmes Offered</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <strong>Program</strong>
                                                </th>
                                                <th>
                                                    <strong>Department</strong>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        Under Graduate
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc. (NEP)</td>
                                                <td>Botany</td>
                                            </tr>
                                            <tr>
                                                <td>B.A. (Journalism)(B.J.M.C)</td>
                                                <td>Journalism And Mass Communication</td>
                                            </tr>
                                            <tr>
                                                <td>B.B.A.</td>
                                                <td>Institute of Business Studies</td>
                                            </tr>
                                            <tr>
                                                <td>B.B.A.(Hospital Administration)</td>
                                                <td>Institute of Business Studies</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Computer Science)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Information Technology)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Chemical Engineering)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Electronics and Communication Engineering)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Mechanical Engineering)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Com.(Honours)</td>
                                                <td>Commerce</td>
                                            </tr>
                                            <tr>
                                                <td>B.A. LLB</td>
                                                <td>Institute of Legal Studies</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(Food Microbiology safety Quality Control)</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>B.P.Ed.</td>
                                                <td>Physical Education</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(Computer Science Honours)</td>
                                                <td>Department of Computer Application</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(NEP)</td>
                                                <td>Chemistry</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(NEP)</td>
                                                <td>Statistics</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(NEP)</td>
                                                <td>Physics</td>
                                            </tr>
                                            <tr>
                                                <td>B.Tech (Agriculture Engineering)</td>
                                                <td>Institute of Engineering And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(NEP)</td>
                                                <td>Zoology</td>
                                            </tr>
                                            <tr>
                                                <td>B.Sc.(NEP)</td>
                                                <td>Mathematics</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Political Science</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Psychology</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Sociology</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>History</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>English</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Economics</td>
                                            </tr>
                                            <tr>
                                                <td>B.A.(NEP)</td>
                                                <td>Hindi</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        Post Graduate
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc. (Agriculture)</td>
                                                <td>Food Science And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Ed.</td>
                                                <td>Education</td>
                                            </tr>
                                            <tr>
                                                <td>M.P.Ed.</td>
                                                <td>Physical Education</td>
                                            </tr>
                                            <tr>
                                                <td>MBA</td>
                                                <td>Institute of Business Studies</td>
                                            </tr>
                                            <tr>
                                                <td>MBA(Hospital Administration)</td>
                                                <td>Institute of Business Studies</td>
                                            </tr>
                                            <tr>
                                                <td>LL.M.</td>
                                                <td>Institute of Legal Studies</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Agriculture)</td>
                                                <td>Horticulture</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Geography</td>
                                            </tr>
                                            <tr>
                                                <td>M.A. (Yoga Science)</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Bioinformatics)</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Medical Microbiology)</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Applied Microbiology)</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Agriculture)(Entom ology)</td>
                                                <td>Plant Protection</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Agriculture)(Plant Pathology)</td>
                                                <td>Plant Protection</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Toxicology</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Urdu</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>English</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>History</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Political Science</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Sociology</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Economics</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Psychology</td>
                                            </tr>
                                            <tr>
                                                <td>MSW</td>
                                                <td>Social Work</td>
                                            </tr>
                                            <tr>
                                                <td>MLibISc</td>
                                                <td>Library Information Science</td>
                                            </tr>
                                            <tr>
                                                <td>MPA</td>
                                                <td>Political Science</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Physics</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Chemistry</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Mathematics</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Botany</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Zoology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Statistics</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.</td>
                                                <td>Biotechnology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Biochemistry)</td>
                                                <td>Chemistry</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Food Nutrition)</td>
                                                <td>Home Science</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Environment Science)</td>
                                                <td>Zoology</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Polymer Science Chemical Technology)</td>
                                                <td>Chemistry</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.</td>
                                                <td>Hindi</td>
                                            </tr>
                                            <tr>
                                                <td>M.Com.</td>
                                                <td>Commerce</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Agriculture)</td>
                                                <td>Genetics Plant Breeding</td>
                                            </tr>
                                            <tr>
                                                <td>M.Sc.(Agriculture)</td>
                                                <td>Seed Science And Technology</td>
                                            </tr>
                                            <tr>
                                                <td>M.A.(J M C)</td>
                                                <td>Journalism And Mass Communication</td>
                                            </tr>
                                            <tr>
                                                <td>MCA</td>
                                                <td>Department Of Computer Application</td>
                                            </tr>
                                            <tr>
                                                <td>MFA(Applied Arts)</td>
                                                <td>Fine Arts</td>
                                            </tr>
                                            <tr>
                                                <td>MFA(Drawing and Painting)</td>
                                                <td>Fine Arts</td>
                                            </tr>
                                            <tr>
                                                <td height={22} colSpan={2}>
                                                    &nbsp;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td height={22} colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        Ph.D.
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Physics</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Zoology</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Microbiology</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Toxicology</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Journalism And Mass Communication</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Education</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Physical Education</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Institute of Business Studies</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Institute of Legal Studies</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>English</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Horticulture</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Genetics Plant Breeding</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Botany</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Chemistry</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Mathematics</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Statistics</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Sociology</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Psychology</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Political Science</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>History</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Economics</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Urdu</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D.&nbsp;</td>
                                                <td>Hindi</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td>D.Sc.</td>
                                                <td>Physics</td>
                                            </tr>
                                            <tr>
                                                <td>DLitt</td>
                                                <td>Political Science</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        PG Diploma
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PG Diploma (Film Production)</td>
                                                <td>Journalism And Mass Communication</td>
                                            </tr>
                                            <tr>
                                                <td>PG Diploma (GIS Remote Sensing)</td>
                                                <td>Geography</td>
                                            </tr>
                                            <tr>
                                                <td>PG Diploma (Yoga Science)</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td>PG Diploma (Jyotir Vigyan)</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td>PG Diploma (Karam Kand)</td>
                                                <td>Sanskrit</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        Diploma
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Urdu </td>
                                                <td>Urdu </td>
                                            </tr>
                                            <tr>
                                                <td>French </td>
                                                <td>Foreign Language</td>
                                            </tr>
                                            <tr>
                                                <td>Russian</td>
                                                <td>Foreign Language</td>
                                            </tr>
                                            <tr>
                                                <td>Vedic &nbsp;Mathematics</td>
                                                <td>Mathematics</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong className="my-heading" style={{ fontSize: 24 }}>
                                                        Certificate Courses
                                                    </strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Proficiency in French</td>
                                                <td>Foreign Language</td>
                                            </tr>
                                            <tr>
                                                <td>Proficiency in Russian</td>
                                                <td>Foreign Language</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;